import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Check } from 'lucide-react';

const PricingSection = () => {
  return (
    <section id="pricing" className="py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Simple, transparent pricing
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            One plan with everything you need. No hidden fees.
          </p>
        </div>
        
        <div className="max-w-md mx-auto">
          <Card className="border-primary shadow-lg">
            <CardHeader className="text-center">
              <CardTitle className="text-2xl">Pro Plan</CardTitle>
              <CardDescription>Complete workforce management</CardDescription>
              <div className="flex items-baseline justify-center space-x-2 mt-4">
                <span className="text-4xl font-bold">€5</span>
                <span className="text-muted-foreground">/ month</span>
              </div>
              <p className="text-sm text-muted-foreground mt-1">
                1–5 employees included · €1/month per additional employee
              </p>
              <p className="text-sm font-semibold text-primary mt-2">
                3-month free trial · No charge until trial ends
              </p>
            </CardHeader>
            
            <CardContent>
              <ul className="space-y-3">
                {[
                  '5 employees included in base plan',
                  '€1/month per additional employee',
                  'Time tracking & attendance',
                  'Leave management',
                  'Shift scheduling',
                  'Payroll reports',
                  'Team management',
                ].map((feature) => (
                  <li key={feature} className="flex items-center">
                    <Check className="h-4 w-4 text-primary mr-3 flex-shrink-0" />
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
            
            <CardFooter>
              <Button className="w-full" size="lg" asChild>
                <Link to="/auth?tab=signup">Start free trial</Link>
              </Button>
            </CardFooter>
          </Card>
          
          <p className="text-center text-sm text-muted-foreground mt-6">
            Cancel anytime. No long-term commitment.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
